import '/assets/styles/sections/app-update-warning.scss';
import { useCallback, useEffect, useRef, useState } from 'react';
import config from '/config';

// Services
import siteServices from '/services/site';

// Context
import { useNavigator } from '@wearetla/tla-essentials-tools/utilities/navigator';
import { useApplication } from '/utilities/application';

// Partials
import Icon from '@wearetla/tla-essentials-tools/partials/icon';
import Btn from '/views/partials/btn';

export const AssetVersionController = () => {
	const lastCheckTimestamp = useRef(0);
	const checkTimerRef = useRef(null);
	const serviceWorkerInstance = useRef(null);
	const [updateNeeded, setUpdateNeeded] = useState(false);

	const { activeRoute } = useNavigator();
	const { isApplication, postMessage } = useApplication();

	const stopInterval = () => {
		if (checkTimerRef.current) {
			clearInterval(checkTimerRef.current);
			checkTimerRef.current = null;
		}
	};

	const updateApp = useCallback(() => {
		serviceWorkerInstance.current?.active?.postMessage?.({ action: 'updateApp' });
		if (isApplication) {
			postMessage('clearCache');
			if (!window?.ReactNativeWebView?.postMessage) {
				window.location.reload(true);
			}
		} else {
			window.location.reload(true);
		}
	}, [isApplication, postMessage]);

	const checkVersion = useCallback(() => {
		if (Date.now() - 10000 > lastCheckTimestamp.current) {
			siteServices
				.checkAppUpdates()
				.then((updateAvailable) => {
					lastCheckTimestamp.current = Date.now();

					if (updateAvailable) {
						setUpdateNeeded(true);
					}
				})
				.catch(() => {});
		}
	}, []);

	useEffect(() => {
		if (window.navigator?.serviceWorker) {
			if (config.enableServiceWorker) {
				window.navigator.serviceWorker.register(`${config.siteURL}/sw.js`).then((instance) => {
					serviceWorkerInstance.current = instance;
					checkTimerRef.current = setInterval(checkVersion, 60000);
				});
			} else {
				window.navigator.serviceWorker.getRegistrations().then(function (registrations) {
					for (let registration of registrations) {
						console.log('Unregistering service workers.');
						registration.unregister();
					}
				});
			}
		}

		return () => {
			stopInterval();
		};
	}, [checkVersion]);

	useEffect(() => {
		checkVersion();
	}, [activeRoute, checkVersion]);

	useEffect(() => {
		if (updateNeeded) {
			serviceWorkerInstance.current?.postMessage?.({ action: 'updateApp' });
		}
	}, [updateNeeded]);

	if (!updateNeeded || !isApplication) {
		return null;
	}

	return (
		<div className="section update-warning">
			<div className="warning-body">
				<Icon className="warning-icon" name="warning" />
				<div className="warning-text">
					{isApplication
						? 'Uygulama için bir güncelleme var.'
						: 'Site için bir güncelleme var. Lütfen sayfayı yenileyin.'}
				</div>
				<Btn onClick={updateApp} className="warning-cta primary big">
					{isApplication ? 'Güncelle' : 'Yenile'}
				</Btn>
			</div>
		</div>
	);
};

export default AssetVersionController;
